import React from 'react';
import {useEffect, useState} from 'react';
import '../App.css';
import { TextField, Tooltip } from '@mui/material';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';

//Hur ofta stripsen ska skicka signaler. Mellan varannan minut till en gång per dygn. Man ska kunna skriva in tid som fritext

// The periodic profile is documented as defaulting to 1 report per hour, so its
// Hours field starts at 1. Every other profile starts empty and falls back to
// the profile's own reports_per_h from constants.js.
const defaultHours = (profile) => profile === 'periodic' ? '1' : '';

// '' / undefined / NaN / negative all count as "nothing entered".
const toPositiveNumber = (value) => {
  const number = Number(value);
  return Number.isFinite(number) && number > 0 ? number : 0;
};

const ReportInterval = (props) => {

  const {onTimeChanged} = props;
  const [hours, setHours] = useState(() => defaultHours(props.profile));
  const [minutes, setMinutes] = useState('');

  useEffect(() => {
    const totalTime_s = toPositiveNumber(hours) * 60 * 60 + toPositiveNumber(minutes) * 60;

    // Nothing usable entered - report undefined so calculateTime falls back to
    // the profile's default reports_per_h instead of dividing by zero.
    if (!totalTime_s) {
      onTimeChanged(undefined);
      return;
    }

    onTimeChanged(3600 / totalTime_s);
  }, [hours, minutes, onTimeChanged]);

  return (
  <>
    <div className="ReportIntervalContainer">
      
      <TimeHeader profile={props.profile}/>

      <TextField 
        id="report-interval-hours" 
        label="Hours" 
        variant="standard" 
        color="primary" 
        type="number"
        placeholder="maximum 24h"
        value={hours}
        InputProps={{ disableUnderline: true }}
        sx={{
          borderBottom: .8,
          borderColor: 'primary.main',
          input: {
            color: "black"
          },
          label: {
            color: "black",
          }
        }}
        onChange={(event) => {setHours(event.target.value) }}
      />
        
      <TextField 
        id="report-interval-minutes" 
        label="Minutes" 
        variant="standard" 
        color="primary" 
        type="number"
        min="0"
        placeholder="minimum 2 min"
        value={minutes}
        InputProps={{ disableUnderline: true }}
        sx={{
          borderBottom: .8,
          borderColor: 'primary.main',
          input: {
            bgColor: 'primary.main',
            color: "black",
          },
          label: {
            color: "black",
          },
        }}
        onChange={(event) => {setMinutes(event.target.value)}}
      />
    </div>
  </>
  );
}

  const TimeHeader = (props) => {
    return(
      <>
      <header className='App'>
        <span>Report interval:</span>

        <Tooltip title='Please enter how often you want the product to send data'>
          <InfoOutlinedIcon
            sx={{ fontSize: 'var(--fs-title)' }}
            color="primary"
          />
        </Tooltip>  
        
      </header> 
      {props.profile === ("periodic") &&
        <p className='Undertitle'>The default value is 1 report per hour</p>  
      }
      {props.profile !== ("periodic") &&
        <p className='Undertitle'>This section is optional and will revert to the default value if nothing is chosen.</p>
      }
      </>
    )
  };

export default ReportInterval;
